import { useDetectI18nextMismatchOnDropdownChange } from "~/hooks/useDetectTranslationMismatch/hooks/useDetectI18nextMismatchOnDropdownChange";
import { useDetectTranslationMismatchOnMerchantLanguageChange } from "~/hooks/useDetectTranslationMismatch/hooks/useDetectTranslationMismatchOnMerchantLanguageChange";

export const useDetectTranslationMismatch = (isLoading = false) => {
  // useDetectTranslationMismatchOnMerchantLanguageChange(isLoading);
  // useDetectI18nextMismatchOnDropdownChange(isLoading);
};
